/*
 * This file is generated by generate_webpack_entries.ts
 */
import {rpAppPath} from "@pg-mono/rp-routes";

import {rpClient} from "../../../client/rp_client";
import {ComparisonToolView} from "../../comparison_tool/views/ComparisonToolView";
const route = [{webpackEntry: "comparisonTool", path: rpAppPath.comparisonTool, component: ComparisonToolView}];

(function () {
    rpClient(route);
})();
/*
 * This file is generated by generate_webpack_entries.ts
 */
import {rpAppPath} from "@pg-mono/rp-routes";

import {rpClient} from "../../../client/rp_client";
import {ComparisonToolView} from "../../comparison_tool/views/ComparisonToolView";
const route = [{webpackEntry: "comparisonTool", path: rpAppPath.comparisonTool, component: ComparisonToolView}];

(function () {
    rpClient(route);
})();
